import Players from '@/services/player/Players';
import PresetCommunityCards from '@/services/PresetCommunityCards';
import GeneralHands from '@/services/hands/GeneralHands';
import shareUrlService from '@/services/share-url-service';
import storeService from '@/store/service';

let state = {
  hasSimulationBeenRun: false,
  presetCommunityCards: new PresetCommunityCards(),
  players: new Players(),
  resultGeneralHands: new GeneralHands(),
  requiredEquity: 50,
};

let mutations = {
  setState: function (state, stateFromServer) {
    shareUrlService.setEquityMatrixStoreState(stateFromServer, state);
  },
  setRequiredEquity: function (state, newRequiredEquity) {
    state.requiredEquity = newRequiredEquity;
  },
  setHasSimulationBeenRun: function (state, value) {
    state.hasSimulationBeenRun = value;
  },

  // player range
  selectGeneralHand: function (state, payload) {
    storeService.selectGeneralHand(state, payload);
  },
  deselectGeneralHand: function (state, payload) {
    storeService.deselectGeneralHand(state, payload);
  },
  selectGeneralHands: function (state, payload) {
    storeService.selectGeneralHands(state, payload);
  },
  deselectGeneralHands: function (state, payload) {
    storeService.deselectGeneralHands(state, payload);
  },
  selectSpecificHand: function (state, payload) {
    storeService.selectSpecificHand(state, payload);
  },
  deselectSpecificHand: function (state, payload) {
    storeService.deselectSpecificHand(state, payload);
  },
  selectSpecificHands: function (state, payload) {
    storeService.selectSpecificHands(state, payload);
  },
  deselectAllGeneralHands: function (state, payload) {
    storeService.deselectAllGeneralHands(state, payload);
  },
  applyExactWeightToGeneralHand: function (state, payload) {
    storeService.applyExactWeightToGeneralHand(state, payload);
  },
  applyExactWeightToGeneralHands: function (state, payload) {
    storeService.applyExactWeightToGeneralHands(state, payload);
  },
  setWeightOfSpecificHand: function (state, payload) {
    storeService.setWeightOfSpecificHand(state, payload);
  },

  // player other
  setWeightToApplyToAddedHands: function (state, payload) {
    storeService.setWeightToApplyToAddedHands(state, payload);
  },
  addComboToCombosToAdd: function (state, payload) {
    storeService.addComboToCombosToAdd(state, payload);
  },
  removeComboFromCombosToAdd: function (state, payload) {
    storeService.removeComboFromCombosToAdd(state, payload);
  },
  narrowRange: function (state, payload) {
    state.players.find(payload.playerIndex).narrowRange(
      payload.checkedHands,
      state.presetCommunityCards
    );
  },

  // controls
  setIndividualPresetCommunityCard: function (state, payload) {
    storeService.setIndividualPresetCommunityCard(state, payload);
  },
  setBoard: function (state, boardCards) {
    storeService.setBoard(state, boardCards);
  },
  removePresetCommunityCard: function (state, position) {
    storeService.removePresetCommunityCard(state, position);
  },
  addPlayer: function (state, payload) {
    storeService.addPlayer(state, payload);
  },
  removePlayer: function (state, playerIndex) {
    storeService.removePlayer(state, playerIndex);
  },
};

export default {
  namespaced: true,
  state: state,
  mutations: mutations,
};

export { state, mutations };



// WEBPACK FOOTER //
// ./src/store/modules/equity-matrix/equity-matrix.js